import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import { Tooltip } from 'antd'

class ConditionalTooltip extends Component {
    state = {

    }

    componentDidMount() {

    }

    render() {
        return (
            this.props.enabled ?
                <Tooltip
                    title={this.props.title}
                    placement={this.props.placement ? this.props.placement : 'top'}
                    overlayClassName='tooltip-custom-background'
                    overlayStyle={{
                        maxWidth: '300px',
                        pointerEvents: 'none',
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                >{this.props.children}</Tooltip>
                :
                this.props.children
        )
    }
}

export default ConditionalTooltip